<div class="banner-container" [ngClass]="[type]">
  <div class="row-layout">
    <div class="banner-content">
      <span class="banner-icon">
        <hyperkit-icon
          [icon]="getIconClass()"
          size="large"
          [color]="type"
        ></hyperkit-icon>
      </span>
      <hyperkit-typography
        variant="body1"
        color="primary"
        class="banner-text"
        >{{ text }}</hyperkit-typography
      >
    </div>

    <div class="banner-actions">
      <button *ngIf="actionText" class="action-button" (click)="onAction()">
        {{ actionText }}
      </button>

      <button
        *ngIf="closable"
        class="close-button"
        (click)="onClose()"
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  </div>
</div>
